export default {
  MockOrganisationData: 'MOCK_ORGANISATION_DATA',
  MockUserData: 'MOCK_USER_DATA',
  MockPaymentContractData: 'MOCK_PAYMENT_CONTRACT_DATA',
  MockPointInteractionData: 'MOCK_POINT_INTERACTION_DATA',
};
